import { useState, useRef } from 'react';
import { useClickOutside } from '@/hooks/useClickOutside';
import { useBackgroundSync } from '@/context/BackgroundSyncContext';
import CircleThreeDotsIcon from '@/assets/icons/circle-three-dots.svg?react';
import styles from './PopoverMenu.module.scss';

interface IPopoverMenu {
  index: number;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onAddToSet?: () => void;
  testId?: string;
  // eslint-disable-next-line no-unused-vars
  onHistory?: (index: number) => void;
  showHistory?: boolean; // need a flag since it depends on user permissions
}

function PopoverMenu({ index, onEdit, onDelete, onCopy, onAddToSet, onHistory, showHistory, testId }: IPopoverMenu) {
  const { isSyncComplete } = useBackgroundSync();
  const [showMenuId, setShowMenuId] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useClickOutside(menuRef, showMenuId, () => setShowMenuId(null));

  const handleClickEdit = () => {
    setShowMenuId(null); // reset menu popover
    onEdit?.();
  };

  const handleClickDelete = () => {
    setShowMenuId(null); // reset menu popover
    onDelete?.();
  };

  const handleClickCopy = () => {
    setShowMenuId(null); // reset menu popover
    onCopy?.();
  };

  const handleAddToSet = () => {
    setShowMenuId(null); // reset menu popover
    onAddToSet?.();
  };

  const handleClickHistory = () => {
    setShowMenuId(null);
    onHistory?.(index);
  };

  return (
    <div className={styles.menu} ref={showMenuId === index ? menuRef : null}>
      <button type="button" className={styles.menuButton} aria-label="Open options menu" data-testid={testId} onClick={() => setShowMenuId(index)}>
        <CircleThreeDotsIcon aria-hidden="true" className={styles.menuIcon} />
      </button>
      {showMenuId === index && (
        <div className={styles.menuPopover}>
          {onEdit && isSyncComplete && (
            <span role="button" onClick={handleClickEdit} data-testid="tourbag-popovermenu-edit">
              Edit
            </span>
          )}
          {showHistory && onHistory && (
            <span role="button" onClick={handleClickHistory} data-testid="tourbag-popovermenu-history">
              History
            </span>
          )}
          {onCopy && isSyncComplete && (
            <span role="button" onClick={handleClickCopy} data-testid="tourbag-popovermenu-copy">
              Copy
            </span>
          )}
          {onDelete && isSyncComplete && (
            <span role="button" onClick={handleClickDelete} data-testid="tourbag-popovermenu-delete">
              Delete
            </span>
          )}
          {onAddToSet && isSyncComplete && (
            <span role="button" onClick={handleAddToSet} data-testid="tourbag-popovermenu-addtoset">
              Add to Set
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default PopoverMenu;
